var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 65,
    viewBox: "0 0 50 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 49.5238C28.4375 49.5238 31.25 46.7381 31.25 43.3333C31.25 39.9286 28.4375 37.1429 25 37.1429C21.5625 37.1429 18.75 39.9286 18.75 43.3333C18.75 46.7381 21.5625 49.5238 25 49.5238ZM43.75 21.6667H40.625V15.4762C40.625 6.93333 33.625 0 25 0C16.375 0 9.375 6.93333 9.375 15.4762H15.3125C15.3125 10.1833 19.6562 5.88095 25 5.88095C30.3438 5.88095 34.6875 10.1833 34.6875 15.4762V21.6667H6.25C2.8125 21.6667 0 24.4524 0 27.8571V58.8095C0 62.2143 2.8125 65 6.25 65H43.75C47.1875 65 50 62.2143 50 58.8095V27.8571C50 24.4524 47.1875 21.6667 43.75 21.6667ZM43.75 58.8095H6.25V27.8571H43.75V58.8095Z",
    fill: "#F9C7C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.c9ea5513d63a6756ace748be4bf64b9a.svg";
export { ForwardRef as ReactComponent };